import { render, staticRenderFns } from "./CreatePanel.vue?vue&type=template&id=28623d60"
import script from "./CreatePanel.vue?vue&type=script&lang=js"
export * from "./CreatePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports